"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newVideoPinComponent = exports.minimumVideoComponentSize = void 0;
const geometry_1 = require("../geometry");
const order_1 = require("../order");
const random_id_1 = require("../random-id");
const pin_component_1 = require("./pin-component");
exports.minimumVideoComponentSize = (0, geometry_1.newSize)(480, 270);
function newVideoPinComponent({ position = pin_component_1.initialPinComponentPosition, size = exports.minimumVideoComponentSize, order = order_1.defaultOrder, settings, source, sourceId, }) {
    if (size.width < exports.minimumVideoComponentSize.width || size.height < exports.minimumVideoComponentSize.height) {
        throw new Error('Video component size is too small');
    }
    return {
        type: 'VIDEO',
        id: (0, random_id_1.randomId)(),
        settings: {
            ...settings,
            source: source || undefined,
            sourceId: sourceId || undefined,
        },
        layout: (0, geometry_1.newBox)(position, size, 0, true),
        order,
    };
}
exports.newVideoPinComponent = newVideoPinComponent;
//# sourceMappingURL=video-pin-component.js.map